import React from "react";
import { ButtonFluxi } from "../../common/Buttons/ButtonFluxi/ButtonFluxi";
import { handleConnect } from "../PaymentMethods/paymentUtils";
import gifs from "../../../assets/icons/gifs.json";

const PaymentMethodsSuccess: React.FC<{
  handleClose: () => void;
}> = ({ handleClose }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={gifs.success}
        className="w-1/2"
        alt="No se encontraron métodos de pago"
      />
      <h1 className="mt-8 mb-12 text-xl font-bold w-[300px] text-center">
        Payment method connected successfully
      </h1>
      <ButtonFluxi
        text="Accept"
        onClick={() => handleClose()}
      />
    </div>
  );
};

export default PaymentMethodsSuccess;
